import { heapTrackProperties } from '@m/utils/heap';

import type { OnboardingVariant } from './deriveVariant';

export type OnboardingAnalyticsStep =
  'ContactInfo' | 'Payment' | 'Phone' | 'ReviewSubscription' | 'Success' | 'Vehicle' | 'VerifyCode';

const FLOW_LABEL: Record<OnboardingVariant, string> = {
  agnostic: 'Agnostic Sign-up',
  enterpriseSub: 'Enterprise Sign-up',
  individualSub: 'Individual Sub Sign-up',
  locationSpecific: 'Start Visit',
};

function track(
  action: 'Completed' | 'Skipped' | 'Viewed',
  step: OnboardingAnalyticsStep,
  variant: OnboardingVariant,
  optional: boolean,
) {
  heapTrackProperties(`SignInOnboarding:${step}:${action}`, {
    flow: FLOW_LABEL[variant],
    optional,
  });
}

export function trackOnboardingStepViewed(
  step: OnboardingAnalyticsStep,
  variant: OnboardingVariant,
  optional = false,
) {
  track('Viewed', step, variant, optional);
}

export function trackOnboardingStepCompleted(
  step: OnboardingAnalyticsStep,
  variant: OnboardingVariant,
  optional = false,
) {
  track('Completed', step, variant, optional);
}

export function trackOnboardingStepSkipped(
  step: OnboardingAnalyticsStep,
  variant: OnboardingVariant,
  optional = true,
) {
  track('Skipped', step, variant, optional);
}
